export enum UtmMedium {
    DEFAULT = 'presentment'
}

export enum UtmCampaignName {
    VIEW = 'view-invoice',
    PAY_VIEW = 'pay-invoice'
}

export enum UtmTerm {
    VIEW = 'view-invoice',
    PAY_VIEW = 'pay-now'
}

export enum UtmContent {
    VIEW = 'pdf-view',
    PAY_VIEW = 'payment-selection'
}

export enum PageName {
    VIEW = 'VIEW',
    PAY_VIEW = 'PAY_VIEW'
}

export enum EventName {
    VIEW_INVOICE = 'view-invoice',
    PAY_NOW_BUTTON = 'pay-now-button',
    CLOSE_PAY_BUTTON = 'close-pay-button',
    PAY_VIEW_INVOICE = 'pay-view-invoice',
    INVOICE_LIST_ERROR = 'invoice-list-error',
    VIEW_INVOICE_LIST = 'view-invoice-list',
    INVOICE_LIST_WARNING ='invoice-list-warning',
    LOGIN_INTRAY = 'login-intray',
    UNLINKED_FROM_INTRAY = 'unlinked-from-intray',
    UNLINK_FROM_INTRAY_BUTTON = 'unlink-from-intray-button',
    SELECTED_COMPANY = 'selected-company'
}

export enum InvoiceListErrorType {
    TIMEOUT = 'timeout',
    EXPIRED_LINK = 'expiredLink',
    EMPTY_INVOICE_LIST = 'emptyInvoiceList',
    ERROR_GETTING_INVOICE = 'errorGettingInvoice'

}

